import { render, staticRenderFns } from "./ModalBattlesSelect.vue?vue&type=template&id=e6b2595e&scoped=true"
import script from "./ModalBattlesSelect.vue?vue&type=script&lang=js"
export * from "./ModalBattlesSelect.vue?vue&type=script&lang=js"
import style0 from "./ModalBattlesSelect.vue?vue&type=style&index=0&id=e6b2595e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6b2595e",
  null
  
)

export default component.exports